import { useEffect, useState } from "react";
import { ProgressSpinner } from 'primereact/progressspinner';
import DashboardTopCompenet from "./dashboardTopCompenet";
import { Fetch, baseUrl } from "../../shared/Fetch";
import DataTableView from "./dataTable";
import { Submission, Requirement, ECIs, POs, Margin } from "./DashboardModel";
import { getBranchECIs, getBranchMargins, getBranchPOs, getBranchRequirments, getBranchSubmissions } from "./BranchData";
import { useLocation } from "react-router-dom";
import { getCompanyECIs, getCompanyMargins, getCompanyPOs, getCompanyRequirments, getCompanySubmissions } from "./CompanyData";
import { Card } from "primereact/card";
import graph from "../../assets/flags/graph-messages.svg.png";
import { Tag } from "primereact/tag";
import { format } from "date-fns";
import { ILogin } from "../../models/Login";
import SalesRank1 from "../../assets/branchRanking/Sales1stRank.jpeg";
import SalesRank2 from "../../assets/branchRanking/Sales2ndRank.jpeg";
import SalesRank3 from "../../assets/branchRanking/Sales3rdRank.jpeg";
import RecruiterRank1 from "../../assets/branchRanking/Rec1stRank.jpeg";
import RecruiterRank2 from "../../assets/branchRanking/Rec2ndRank.jpeg";
import RecruiterRank3 from "../../assets/branchRanking/Rec3rdRank.jpeg";
// import JobVrittaVideo from '../../assets/branchRanking/JobvrittaVedio.mp4';
// import AnVideo from '../../assets/branchRanking/AnVideo.mp4';
// import axios from 'axios';

// import { Carousel } from 'primereact/carousel';
// import { Button } from "primereact/button";
import SalesRecruiter from "../../assets/branchRanking/Sales-Recruiter.mp4";
import TLTeam from "../../assets/branchRanking/TL-Team.mp4";
import { ImageShowLike } from "./ImageShowLike";
import { DemoMilestone } from "../demoMilestone";


import SatyajitNayak from "../../assets/flags/User_Image_1.jpeg";
import PuneetMudgal from "../../assets/flags/User_Image_2.jpg";
import AdityaRana from "../../assets/flags/User_Image_3.jpg";
import GirijeshBhardwaj from "../../assets/flags/User_Image_4.jpeg";
import PankajYadav from "../../assets/flags/User_Image_5.jpg";
import VishantTomar from "../../assets/flags/User_Image_6.jpeg";
import ShivansuSingh from "../../assets/flags/User_Image_7.jpeg";
import AnchalShrivastav from "../../assets/flags/User_Image_8.jpeg";
import KuldeepSharma from "../../assets/flags/User_Image_9.jpeg";
import SubodhKumar from "../../assets/flags/User_Image_10.jpeg";
import AniketSingh from "../../assets/flags/User_Image_11.jpeg";
import NaveenSingh from "../../assets/flags/User_Image_12.jpeg";
import HarshSingh from "../../assets/flags/User_Image_13.jpeg";
import ArtiSharma from "../../assets/flags/User_Image_14.jpeg";
import SujitKumarDash from "../../assets/flags/User_Image_15.jpeg";
import ShivaniSharma from "../../assets/flags/User_Image_16.jpeg";
import VikasVerm from "../../assets/flags/User_Image_17.jpeg";
import MichaelSmith from "../../assets/flags/User_Image_18.jpeg";
import AbhishekYadav from "../../assets/flags/User_Image_19.jpeg";
import VipinKumar from "../../assets/flags/User_Image_20.jpeg";
import LovelySingh from "../../assets/flags/User_Image_21.jpeg";
//import MalaShah from "../../assets/flags/User_Image_22.jpeg";
import RhoitSingh from "../../assets/flags/User_Image_23.jpeg";
import KhushbooRajput from "../../assets/flags/User_Image_24.jpeg";
import PiyushVarshney from "../../assets/flags/User_Image_25.jpeg";
import PankajUpadhyay from "../../assets/flags/User_Image_26.jpeg";
import SumitPratapSingh from "../../assets/flags/User_Image_27.jpeg";
import RonakGupta from "../../assets/flags/User_Image_28.jpeg";
import MohdIqbalKhan from "../../assets/flags/User_Image_29.jpeg";
import LipsaMohnty from "../../assets/flags/User_Image_30.jpeg";
import ShaikMohasin from "../../assets/flags/User_Image_31.jpeg";
import ShivanshuSingh from "../../assets/flags/User_Image_32.jpeg";
import DeepakSingh from "../../assets/flags/User_Image_33.jpeg";
import ShrastiSingh from "../../assets/flags/User_Image_34.jpeg";
import RaviDubey from "../../assets/flags/User_Image_35.jpeg";
import AnkitaRoul from "../../assets/flags/User_Image_37.jpg";
import BhumikaKatyal from "../../assets/flags/User_Image_38.jpg";
import PrakharShukla from "../../assets/flags/User_Image_39.jpg";
import ShivanshSingh from "../../assets/flags/User_Image_40.jpeg";
import AbhinavKumar from "../../assets/flags/User_Image_41.jpeg";
import AmitKumarPradhan from "../../assets/flags/User_Image_42.jpeg";
import AnandPrajapati from "../../assets/flags/User_Image_43.jpeg";
import TusharKumarSahoo from "../../assets/flags/User_Image_44.jpeg";
import SanskarDauneria from "../../assets/flags/User_Image_45.jpeg";
import Shipra from "../../assets/flags/User_Image_46.jpeg";
import PankajYadav1 from "../../assets/flags/User_Image_47.jpeg";
//import NitinShukla from "../../assets/flags/User_Image_48.jpeg";
//import JanhaviSingh from "../../assets/flags/User_Image_49.jpeg";
import PawanTiwari from "../../assets/flags/User_Image_50.jpeg";
import ShipraYadav from "../../assets/flags/User_Image_51.jpeg";
import InderMohanNegi from "../../assets/flags/User_Image_52.jpeg";
import AnupamSingh from "../../assets/flags/User_Image_53.jpeg";
import AyasJena from "../../assets/flags/User_Image_54.jpeg";
import NitinShukla from "../../assets/flags/User_Image_55.jpeg";
import VibhorSingh from "../../assets/flags/User_Image_56.jpeg";
import MalaShah from "../../assets/flags/User_Image_57.jpeg";
import RohitSingh from "../../assets/flags/User_Image_58.jpeg";
import JanhaviSingh from "../../assets/flags/User_Image_59.jpeg";
import SameekshaSingh from "../../assets/flags/User_Image_60.jpeg";
import RishuUpadhyay from "../../assets/flags/User_Image_61.jpeg";
import JayantKumar from "../../assets/flags/User_Image_62.jpeg";
import MohdFazilRaza from "../../assets/flags/User_Image_63.jpeg";
import NareshKumarJena from "../../assets/flags/User_Image_64.jpeg";
import VanshPratapSingh from "../../assets/flags/User_Image_65.jpeg";
import ShreyaSrivastava from "../../assets/flags/User_Image_66.jpeg";
import AnkitaPorwal from "../../assets/flags/User_Image_67.jpeg";
import ArjunSingh from "../../assets/flags/User_Image_68.jpeg";
import JanviJha from "../../assets/flags/User_Image_69.jpeg";
import TrainerApprovalForm from "../carnivalTraining/trainingDashboard/TrainerApprovalForm";
import { TrainerScheduleApprovalForm } from "../carnivalTraining/trainingDashboard/TrainerScheduleApprovalForm";
import { TodayTrainingDispaly } from "../carnivalTraining/trainingDashboard/TodayTrainingDispaly";

const letData: {
    order: number,
    loginID: number,
    name: string,
    image: any
}[] = [
        {
            order: 1,
            loginID: 2588,
            name: "Girijesh Bhardwaj",
            image: GirijeshBhardwaj
        },
        {
            order: 2,
            loginID: 11845,
            name: "Aditya Rana",
            image: AdityaRana
        },
        {
            order: 3,
            loginID: 3836,
            name: "Satyajit Nayak",
            image: SatyajitNayak
        },
        {
            order: 4,
            loginID: 12171,
            name: "Puneet Mudgal",
            image: PuneetMudgal
        },
        {
            order: 5,
            loginID: 12113,
            name: "Pankaj Yadav",
            image: PankajYadav
        },
        {
            order: 6,
            loginID: 5708,
            name: "Visant Tomar",
            image: VishantTomar
        },
        {
            order: 7,
            loginID: 2388,
            name: "Shivansu Singh",
            image: ShivansuSingh
        },
        {
            order: 8,
            loginID: 12145,
            name: "Anchal Srivastava",
            image: AnchalShrivastav
        },
        {
            order: 9,
            loginID: 5866,
            name: "Kuldeep Sharma",
            image: KuldeepSharma
        },
        {
            order: 10,
            loginID: 4166,
            name: "Subodh Kumar",
            image: SubodhKumar
        },
        {
            order: 11,
            loginID: 12379,
            name: "Naveen Singh",
            image: NaveenSingh
        },
        {
            order: 12,
            loginID: 11792,
            name: "Harsh Singh",
            image: HarshSingh
        },
        {
            order: 13,
            loginID: 4470,
            name: "Aniket Singh",
            image: AniketSingh
        },
        {
            order: 14,
            loginID: 3736,
            name: "Sujit Kumar Dash",
            image: SujitKumarDash
        },
        {
            order: 15,
            loginID: 1365,
            name: "Arti Sharma",
            image: ArtiSharma
        },
        { order: 16, loginID: 5887, name: "Michael Smith", image: MichaelSmith },
        { order: 17, loginID: 12065, name: "Abhishek Yadav", image: AbhishekYadav },
        { order: 18, loginID: 11673, name: "Shivani Sharma", image: ShivaniSharma },
        { order: 19, loginID: 11855, name: "Vikas Verma", image: VikasVerm },
        { order: 20, loginID: 5840, name: "Vipin Kumar", image: VipinKumar },
        { order: 21, loginID: 11763, name: "Lovely Singh", image: LovelySingh },
        { order: 22, loginID: 11733, name: "Mala Shah", image: MalaShah },
        { order: 23, loginID: 11750, name: "Rhoit Singh", image: RhoitSingh },
        { order: 24, loginID: 3783, name: "Khushboo Rajput", image: KhushbooRajput },
        { order: 25, loginID: 3793, name: "Piyush Varshney", image: PiyushVarshney },
        { order: 26, loginID: 3694, name: "Sumit Pratap Singh", image: SumitPratapSingh },
        { order: 27, loginID: 5611, name: "Pankaj Upadhyay", image: PankajUpadhyay },
        { order: 28, loginID: 4430, name: "Ronak Gupta", image: RonakGupta },
        { order: 29, loginID: 12038, name: "Mohd Iqbal Khan", image: MohdIqbalKhan },
        { order: 30, loginID: 5628, name: "Lipsa Mohnty", image: LipsaMohnty },
        { order: 31, loginID: 4094, name: "Shaik Mohasin", image: ShaikMohasin },
        { order: 32, loginID: 11753, name: "Deepak Singh", image: DeepakSingh },
        { order: 33, loginID: 9204, name: "Shrasti Singh", image: ShrastiSingh },
        { order: 34, loginID: 2388, name: "Shivanshu Singh", image: ShivanshuSingh },
        { order: 35, loginID: 4298, name: "Ravi Dubey", image: RaviDubey },
        { order: 37, loginID: 4097, name: "Ankita Roul", image: AnkitaRoul },
        { order: 38, loginID: 11958, name: "Bhumika Katyal", image: BhumikaKatyal },
        { order: 39, loginID: 12135, name: "Prakhar Shukla", image: PrakharShukla },
        { order: 40, loginID: 12310, name: "Shivansh Singh", image: ShivanshSingh },
        { order: 41, loginID: 4538, name: "Amit Kumar Pradhan", image: AmitKumarPradhan },
        { order: 42, loginID: 3902, name: "Abhinav Kumar", image: AbhinavKumar },
        { order: 43, loginID: 5779, name: "Anand Prajapati", image: AnandPrajapati },
        { order: 44, loginID: 11875, name: "Tushar Kumar Sahoo", image: TusharKumarSahoo },
        { order: 45, loginID: 5784, name: "Sanskar Dauneria", image: SanskarDauneria },
        { order: 46, loginID: 0, name: "Shipra", image: Shipra },
        { order: 47, loginID: 12113, name: "Pankaj Yadav", image: PankajYadav1 },
        { order: 48, loginID: 11838, name: "Nitin Shukla", image: NitinShukla },
        { order: 50, loginID: 2585, name: "Janhavi Singh", image: JanhaviSingh },
        { order: 49, loginID: 2438, name: "Pawan Tiwari", image: PawanTiwari },
        { order: 51, loginID: 330, name: "Shipra Yadav", image: ShipraYadav },
        { order: 52, loginID: 4567, name: "Inder Mohan Negi", image: InderMohanNegi },
        { order: 53, loginID: 11761, name: "Anupam Singh", image: AnupamSingh },
        { order: 54, loginID: 3722, name: "Ayas Jena", image: AyasJena },
        { order: 55, loginID: 11838, name: "Nitin Shukla", image: NitinShukla },
        { order: 56, loginID: 128, name: "VibhorSingh", image: VibhorSingh },
        { order: 57, loginID: 11733, name: "Mala Shah", image: MalaShah },
        { order: 58, loginID: 11750, name: "Rohit Singh", image: RohitSingh },
        { order: 60, loginID: 2585, name: "Janhavi Singh", image: JanhaviSingh },
        { order: 61, loginID: 11957, name: "Sameeksha Singh", image: SameekshaSingh },
        { order: 62, loginID: 4431, name: "Rishu Upadhyay", image: RishuUpadhyay },
        { order: 63, loginID: 12334, name: "Jayant Kumar", image: JayantKumar },
        { order: 64, loginID: 12211, name: "Mohd Fazil Raza", image: MohdFazilRaza },
        { order: 65, loginID: 3735, name: "Naresh Kumar Jena", image: NareshKumarJena },
        { order: 66, loginID: 11935, name: "Vansh Pratap Singh", image: VanshPratapSingh },
        { order: 67, loginID: 4331, name: "Shreya Srivastava", image: ShreyaSrivastava },
        { order: 68, loginID: 3658, name: "Ankita Porwal", image: AnkitaPorwal },
        { order: 69, loginID: 4022, name: "Arjun Singh", image: ArjunSingh },
        { order: 70, loginID: 12312, name: "Janvi Jha", image: JanviJha },
    ];


export const Dashboard = () => {
    const [branchRequirements, setBranchRequirements] = useState<Array<Requirement>>([]);
    const [branchSubmissions, setBranchSubmissions] = useState<Array<Submission>>([]);
    const [branchECI, setBranchECI] = useState<Array<ECIs>>([]);
    const [branchPO, setBranchPO] = useState<Array<POs>>([]);
    const [branchMargim, setBranchMargin] = useState<Array<Margin>>([]);

    const [companyRequirements, setCompanyRequirements] = useState<Array<Requirement>>([]);
    const [companySubmissions, setCompanySubmissions] = useState<Array<Submission>>([]);
    const [companyECI, setCompanyECI] = useState<Array<ECIs>>([]);
    const [companyPO, setCompanyPO] = useState<Array<POs>>([]);
    const [companyMargim, setCompanyMargin] = useState<Array<Margin>>([]);
    const [twoVideo, setTwoVideo] = useState<boolean>(true);


    const [dashData, setDashData] = useState({
        companyCount: "",
        branchCount: "",
        salesCount: "",
        recruiterCount: "",
    })
    const [dashData1, setDashData1] = useState({
        pO_Date: "",
        daysAgo: ""

    })
    const [dashData2, setDashData2] = useState({
        monthlyECI: "",
        quaterlyECI: "",
        yearlyECI: "",
        monthlyPO: "",
        quarterlyPO: "",
        yearlyPO: "",
    })

    const [incentivePO, setIncentivePO] = useState({
        monthlyPOAmount: null,
        yearlyPOAmount: null,
        overAllPOAmount: null,
    });

    const Location = useLocation();

    const getDashTopData = async () => {
        const response = await Fetch("Dashboard/admin", "GET", null, null, null);
        const data = await response?.json();

        setDashData({
            ...dashData, companyCount: data.companyCount, branchCount: data.branchCount, salesCount: data.salesCount, recruiterCount: data.recruiterCount
        });

    }

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });



    const getDashTopPoData = async () => {
        const response = await Fetch("Dashboard/poDate", "GET", null, null, null);
        const data = await response?.json();

        setDashData1({
            ...dashData1, pO_Date: data[0].pO_Date, daysAgo: data[0].daysAgo
        });

    }

    const getDashECIPoData = async () => {
        const response = await Fetch("Dashboard/eciPoCount", "GET", null, null, null);
        const data = await response?.json();
        setDashData2({
            ...dashData2, monthlyECI: data[0].monthlyECI, quaterlyECI: data[0].quaterlyECI, yearlyECI: data[0].yearlyECI, monthlyPO: data[0].monthlyPO, yearlyPO: data[0].yearlyPO, quarterlyPO: data[0].quarterlyPO
        });
    }
    useEffect(() => {
        getDashTopData();
        getDashTopPoData();
        getDashECIPoData();
        // PoTotalAmountInCurrentMonth();
        // PoTotalAmountInCurrentYear();
        // PoTotalAmountInCurrentOverAll();

        // const getBranchData=async()=>{

        //     const RespBranchReq=await getBranchRequirments();
        //     const RespBranchSub=await getBranchSubmissions();
        //     const RespBranchEci=await getBranchECIs();
        //     const RespBranchPo=await getBranchPOs();
        //     const RespBranchMargin=await getBranchMargins();

        //     setBranchRequirements(RespBranchReq);
        //     setBranchSubmissions(RespBranchSub);
        //     setBranchECI(RespBranchEci);
        //     setBranchPO(RespBranchPo);
        //     setBranchMargin(RespBranchMargin);

        //     const RespCompanyReq=await getCompanyRequirments();
        //     const RespCompanySub=await getCompanySubmissions();
        //     const RespCompanyEci=await getCompanyECIs();
        //     const RespCompanyPo=await getCompanyPOs();
        //     const RespCompanyMargin=await getCompanyMargins();


        //     setCompanyRequirements(RespCompanyReq);
        //     setCompanySubmissions(RespCompanySub);
        //     setCompanyECI(RespCompanyEci);
        //     setCompanyPO(RespCompanyPo);
        //     setCompanyMargin(RespCompanyMargin);
        // }
        // getBranchData();

    }, []);

    const pDate = (rowData: any) => {
        let date;
        if (rowData) date = format(new Date(rowData), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const PoTotalAmountInCurrentMonth = async () => {
        const response = await Fetch("InvoiceTracking/allPOlist", "GET", null, "type=month", null);
        if (response) {
            const data: any = await parseFloat(await response.text());
            // console.log(data);
            setIncentivePO(prev => prev = { ...prev, monthlyPOAmount: data });
            const response2 = await Fetch("InvoiceTracking/allPOlist", "GET", null, "type=year", null);
            if (response2) {
                const data2: any = await parseFloat(await response2.text());
                // console.log(data);
                setIncentivePO(prev => prev = { ...prev, yearlyPOAmount: data2 });
                const response3 = await Fetch("InvoiceTracking/allPOlist", "GET", null, null, null);
                if (response3) {
                    const data3: any = await parseFloat(await response3.text());
                    // console.log(data);
                    setIncentivePO(prev => prev = { ...prev, overAllPOAmount: data3 });
                }
            }
        }
    };
    // const PoTotalAmountInCurrentYear = async () => {
    //     const response2 = await Fetch("InvoiceTracking/allPOlist", "GET", null, "type=year", null);
    //     if (response2) {
    //         const data: any = await parseFloat(await response2.text());
    //         // console.log(data);
    //         setIncentivePO({ ...incentivePO, yearlyPOAmount: data });
    //     }
    // };
    // const PoTotalAmountInCurrentOverAll = async () => {
    //     const response3 = await Fetch("InvoiceTracking/allPOlist", "GET", null, null, null);
    //     if (response3) {
    //         const data: any = await parseFloat(await response3.text());
    //         // console.log(data);
    //         setIncentivePO({ ...incentivePO, overAllPOAmount: data });
    //     }
    // };
    useEffect(() => {
        let curretnDate = new Date();
        if (curretnDate.getHours() >= 9) {
            setTwoVideo(false);
        }
    });


    return (
        <div>
            {/* <Button onClick={() => callAllPoApi()}>Show All PO Details List</Button> */}
            {/* <div className="flex flex-row justify-content-between align-items-center" style={{ width: "100%" }}>
                <p className="text-2xl underline" style={{ color: "red", fontWeight: "bolder" }}>Video Uploaded On: 13-05-2024</p>
                <p className="text-2xl underline" style={{ color: "red", fontWeight: "bolder" }}>Report: VYZE Noida</p>
            </div> */}
            {/* <video width="100%" height="500" controls >
                <source src={JobVrittaVideo} type="video/mp4" />
            </video> */}
            {/* {showCarousel && <div className="card">
                <Carousel value={videos} numScroll={1} numVisible={2} responsiveOptions={responsiveOptions} itemTemplate={productTemplate} />
            </div>} */}
            {/* <p:media value="/resources/demo/media/guide.pdf" width="100%" height="300px">
                Your browser can't display pdf, <h:outputLink
                    value="#{request.contextPath}/resources/demo/media/guide.pdf">click</h:outputLink> to download pdf instead.
            </p:media> */}
            {/* <TodayTrainingDispaly /> */}
            {/* <TrainerApprovalForm /> */}
            {/* <TrainerScheduleApprovalForm /> */}
            {/* <DemoMilestone />
            <div style={{ width: "100%", height: "57vh", display: "block", border: "1px solid #ccc", margin: "0 auto", overflowY: "scroll" }}>
                {letData
                    .sort((a, b) => b.order - a.order)
                    .map((item: any, index: number) => (
                        <div key={index}>
                            <ImageShowLike loginID={item.loginID} image={item.image} />
                        </div>
                    ))}
            </div> */}

            {twoVideo && <div className="flex flex-row justify-content-between align-items-center gap-3" style={{ width: "100%" }}>
                <div className="flex">
                    <video width="100%" height="500" controls autoPlay={true}>
                        <source src={SalesRecruiter} type="video/mp4" /></video>
                </div>
                <div className="flex">
                    <video width="100%" height="500" controls autoPlay={true}>
                        <source src={TLTeam} type="video/mp4" />
                    </video></div>
            </div>}

            <p className="text-2xl underline" style={{ color: "red", fontWeight: "bolder" }}>Team Sales</p>
            <div className="flex flex-row justify-content-between align-items-center mb-3">
                <img src={SalesRank1} style={{ width: "30%" }} alt="rank1" />
                <img src={SalesRank2} style={{ width: "30%" }} alt="rank2" />
                <img src={SalesRank3} style={{ width: "30%" }} alt="rank3" />
            </div>
            <p className="text-2xl underline" style={{ color: "red", fontWeight: "bolder" }}>Team Recruitment</p>
            <div className="flex align-content-center justify-content-between mb-3">
                <img src={RecruiterRank1} style={{ width: "30%" }} alt="rank1" />
                <img src={RecruiterRank2} style={{ width: "30%" }} alt="rank2" />
                <img src={RecruiterRank3} style={{ width: "30%" }} alt="rank3" />
            </div>
            <div className="grid">
                <div className="col-12 md:col-6 xl:col-3">
                    <Card className="card bg-cyan-400  h-9rem">
                        <div className="flex justify-content-between h-2rem">
                            <div>
                                <div className="summary-box-title text-white-alpha-90">Companies</div>
                                <p className="text-white-alpha-90">0000</p>
                            </div>
                            <div>
                                <div className="summary-box-title text-white-alpha-90">Companies</div>
                                <p className="text-white-alpha-90">0000</p>
                            </div>
                        </div>
                        <img src={graph} alt="sapphire" className="summary-box-graph my-0 w-full" />
                    </Card>
                </div>
                <div className="col-12 md:col-6 xl:col-3">
                    <Card className="card bg-green-500 h-9rem">
                        <div className="flex justify-content-between h-2rem">
                            <div>
                                <div className="summary-box-title text-white-alpha-90">Branches</div>
                                <p className="text-white-alpha-90">0000</p>
                            </div>
                            <div>
                                <div className="summary-box-title text-white-alpha-90">Branches</div>
                                <p className="text-white-alpha-90">0000</p>
                            </div>
                        </div>
                        <img src={graph} alt="sapphire" className="summary-box-graph my-0 w-full" />
                    </Card>
                </div>
                <div className="col-12 md:col-6 xl:col-3">
                    <Card className="card bg-purple-500  h-9rem">
                        <div className="flex justify-content-between h-2rem">
                            <div>
                                <div className="summary-box-title text-white-alpha-90">Sales</div>
                                <p className="text-white-alpha-90">0000</p>
                            </div>
                            <div>
                                <div className="summary-box-title text-white-alpha-90">Sales</div>
                                <p className="text-white-alpha-90">0000</p>
                            </div>
                        </div>
                        <img src={graph} alt="sapphire" className="summary-box-graph my-0 w-full" />
                    </Card>
                </div>
                <div className="col-12 md:col-6 xl:col-3">
                    <Card className="card bg-orange-500  h-9rem">
                        <div className="flex justify-content-between h-2rem">
                            <div>
                                <div className="summary-box-title text-white-alpha-90">Recruiters</div>
                                <p className="text-white-alpha-90">0000</p>
                            </div>
                            <div>
                                <div className="summary-box-title text-white-alpha-90">Recruiters</div>
                                <p className="text-white-alpha-90">0000</p>
                            </div>
                        </div>
                        <img src={graph} alt="sapphire" className="summary-box-graph my-0 w-full" />
                    </Card>
                </div>
            </div>

            {<div className="grid">
                <DashboardTopCompenet box={"1"} title={"COMPANIES"} num={`${dashData.companyCount}`} logo={"pi pi-building"} />
                <DashboardTopCompenet box={"2"} title={"BRANCHES"} num={`${dashData.branchCount}`} logo={"pi pi-sitemap"} />
                <DashboardTopCompenet box={"3"} title={"SALES"} num={`${dashData.salesCount}`} logo={"pi pi-users"} />
                <DashboardTopCompenet box={"4"} title={"RECRUITERS"} num={`${dashData.recruiterCount}`} logo={"pi pi-users"} />
            </div>}


            {(_roles.includes(2) || _roles.includes(3)) && <div className="grid">
                <div className="col-12 md:col-6 xl:col-3">
                    <Tag className="grid-nogutter widget-overview-box widget-overview-box" style={{ background: 'linear-gradient(-225deg,#26C6DA 0%,#79dbe8 48%,#0a84ab 100%)', width: '100%' }}>
                        < div className="flex justify-content-evenly gap-2">
                            {/* <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }} /> */}
                            {/* <i className="pi pi-user"  style={{ fontSize: "1rem", color:"rgb(25, 118, 210)", background:"white"}}></i> */}
                            <i className="pi pi-calendar text-xl" style={{ fontSize: "1rem" }}></i>
                            <span className="text-base text-xl">Last Po Date : </span>
                            <span className="text-base text-xl">{pDate(dashData1.pO_Date)}</span>
                        </div>
                    </Tag>
                </div>
                <div className="col-12 md:col-6 xl:col-3">
                    <Tag className="grid-nogutter widget-overview-box widget-overview-box" style={{ background: 'linear-gradient(-225deg,#0aab2e 0%,#79c489 48%,#267036 100%)', width: '100%' }}>
                        < div className="flex align-items-center gap-2">
                            {/* <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }} /> */}
                            <i className="pi pi-calendar text-xl" style={{ fontSize: "1rem" }}></i>
                            <span className="text-base text-xl">PO before Days : </span>
                            <span className="text-base text-xl">{dashData1.daysAgo}</span>

                        </div>
                    </Tag>
                </div>

                <div className="col-12 md:col-6 xl:col-3">
                    <Tag className="grid-nogutter widget-overview-box widget-overview-box" style={{ background: 'linear-gradient(-225deg,#AC32E4 0%,#7918F2 48%,#4801FF 100%)', width: '100%' }}>
                        < div className="flex align-items-center gap-2">
                            {/* <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }} /> */}
                            <i className="pi pi-calendar text-xl" style={{ fontSize: "1rem" }}></i>
                            <span className="text-base text-xl">Monthly PO : </span>
                            <span className="text-base text-xl">{dashData2.monthlyPO}</span>

                        </div>
                    </Tag>
                </div>

                <div className="col-12 md:col-6 xl:col-3">
                    <Tag className="grid-nogutter widget-overview-box widget-overview-box" style={{ background: 'linear-gradient(-225deg,#ff8a00 0%,#daa261 48%,#e47b00 100%)', width: '100%' }}>
                        < div className="flex align-items-center gap-2">
                            {/* <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }} /> */}
                            <i className="pi pi-calendar text-xl" style={{ fontSize: "1rem" }}></i>
                            <span className="text-base text-xl">quarterly PO : </span>
                            <span className="text-base text-xl">{dashData2.quarterlyPO}</span>

                        </div>
                    </Tag>
                </div>
            </div>}


            {(_roles.includes(2) || _roles.includes(3)) && <div className="grid">
                <div className="col-12 md:col-6 xl:col-3">
                    <Tag className="grid-nogutter widget-overview-box widget-overview-box" style={{ background: 'linear-gradient(-225deg,#26C6DA 0%,#79dbe8 48%,#0a84ab 100%)', width: '100%' }}>
                        < div className="flex justify-content-between gap-2">
                            {/* <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }} /> */}
                            {/* <i className="pi pi-user"  style={{ fontSize: "1rem", color:"rgb(25, 118, 210)", background:"white"}}></i> */}
                            <i className="pi pi-calendar text-xl" style={{ fontSize: "1rem" }}></i>
                            <span className="text-base text-xl">Yearly PO : </span>
                            <span className="text-base text-xl">{dashData2.yearlyPO}</span>


                        </div>
                    </Tag>
                </div>
                <div className="col-12 md:col-6 xl:col-3">
                    <Tag className="grid-nogutter widget-overview-box widget-overview-box" style={{ background: 'linear-gradient(-225deg,#0aab2e 0%,#79c489 48%,#267036 100%)', width: '100%' }}>
                        < div className="flex align-items-center gap-2">
                            {/* <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }} /> */}
                            <i className="pi pi-calendar text-xl" style={{ fontSize: "1rem" }}></i>
                            <span className="text-base text-xl">Monthly ECI : </span>
                            <span className="text-base text-xl">{dashData2.monthlyECI}</span>

                        </div>
                    </Tag>
                </div>

                <div className="col-12 md:col-6 xl:col-3">
                    <Tag className="grid-nogutter widget-overview-box widget-overview-box" style={{ background: 'linear-gradient(-225deg,#AC32E4 0%,#7918F2 48%,#4801FF 100%)', width: '100%' }}>
                        < div className="flex align-items-center gap-2">
                            {/* <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }} /> */}
                            <i className="pi pi-calendar text-xl" style={{ fontSize: "1rem" }}></i>
                            <span className="text-base text-xl">quarterly ECI :</span>
                            <span className="text-base text-xl">{dashData2.quaterlyECI}</span>
                        </div>
                    </Tag>
                </div>

                <div className="col-12 md:col-6 xl:col-3">
                    <Tag className="grid-nogutter widget-overview-box widget-overview-box" style={{ background: 'linear-gradient(-225deg,#ff8a00 0%,#daa261 48%,#e47b00 100%)', width: '100%' }}>
                        < div className="flex align-items-center gap-2">
                            {/* <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }} /> */}
                            <i className="pi pi-calendar text-xl" style={{ fontSize: "1rem" }}></i>
                            <span className="text-base text-xl">Yearly ECI :</span>
                            <span className="text-base text-xl">{dashData2.yearlyECI}</span>
                        </div>
                    </Tag>
                </div>
            </div>}

            {/* {(_roles.includes(2) || _roles.includes(3) || _roles.includes(4) || _roles.includes(5) || _roles.includes(6)) && <div className="grid">
                <div className="col-12 md:col-6 xl:col-3">
                    <Tag className="grid-nogutter widget-overview-box widget-overview-box" style={{ background: 'linear-gradient(-225deg,#26C6DA 0%,#79dbe8 48%,#0a84ab 100%)', width: '100%' }}>
                        < div className="flex justify-content-between gap-2">
                            <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }} />
                            <i className="pi pi-user"  style={{ fontSize: "1rem", color:"rgb(25, 118, 210)", background:"white"}}></i>
                            <i className="pi pi-calendar text-xl" style={{ fontSize: "1rem" }}></i>
                            <span className="text-base text-xl">Over All Total Incentive : </span>
                            <span className="text-base text-xl">₹ {(incentivePO.overAllPOAmount || 0) * 80}</span>


                        </div>
                    </Tag>
                </div>

                <div className="col-12 md:col-6 xl:col-3">
                    <Tag className="grid-nogutter widget-overview-box widget-overview-box" style={{ background: 'linear-gradient(-225deg,#0aab2e 0%,#79c489 48%,#267036 100%)', width: '100%' }}>
                        < div className="flex align-items-center gap-2">
                            <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }} />
                            <i className="pi pi-calendar text-xl" style={{ fontSize: "1rem" }}></i>
                            <span className="text-base text-xl">This Year Total Incentive : </span>
                            <span className="text-base text-xl">₹ {(incentivePO.yearlyPOAmount || 0) * 80}</span>

                        </div>
                    </Tag>
                </div>

                <div className="col-12 md:col-6 xl:col-3">
                    <Tag className="grid-nogutter widget-overview-box widget-overview-box" style={{ background: 'linear-gradient(-225deg,#AC32E4 0%,#7918F2 48%,#4801FF 100%)', width: '100%' }}>
                        < div className="flex align-items-center gap-2">
                            <img alt="Country" src="/images/flag/flag_placeholder.png" className="flag flag-it" style={{ width: '18px' }} />
                            <i className="pi pi-calendar text-xl" style={{ fontSize: "1rem" }}></i>
                            <span className="text-base text-xl">This Month Total Incentive :</span>
                            <span className="text-base text-xl">₹ {(incentivePO.monthlyPOAmount || 0) * 80}</span>
                        </div>
                    </Tag>
                </div>
            </div>} */}









            {/* <div style={{height: 400, display:"block", width: '80%' }} className='Chart Bar Nivo'><MyResponsiveBar data={Bardata}/></div> */}

            {/* {Location.pathname==="/branchdashboard" && branchRequirements.length>0 && branchSubmissions.length>0 && <DataTableView ReqData={branchRequirements} SubData={branchSubmissions} ECIData={[]} POData={[]} MarginData={[]} which={"ReqSub"} tabOf={"branch"}/>}
            {Location.pathname==="/branchdashboard" && branchRequirements.length===0 && branchSubmissions.length===0 && <ProgressSpinner className="m-auto left-50 mt-8"/>}
            {Location.pathname==="/branchdashboard" && branchRequirements.length>0 && branchSubmissions.length>0 && <DataTableView ReqData={[]} SubData={[]} ECIData={branchECI} POData={branchPO} MarginData={[]} which={"EciPo"} tabOf={"branch"}/>}
            {Location.pathname==="/branchdashboard" && branchRequirements.length>0 && branchSubmissions.length>0 && <DataTableView ReqData={[]} SubData={[]} ECIData={[]} POData={[]} MarginData={branchMargim} which={"Margin"} tabOf={"branch"}/>}

            {Location.pathname==="/companydashboard" && companyRequirements.length>0 && companySubmissions.length>0 && <DataTableView ReqData={companyRequirements} SubData={companySubmissions} ECIData={[]} POData={[]} MarginData={[]} which={"ReqSub"} tabOf={"company"}/>}
            {Location.pathname==="/companydashboard" && companyRequirements.length===0 && companySubmissions.length===0 && <ProgressSpinner className="m-auto left-50 mt-8"/>}
            {Location.pathname==="/companydashboard" && companyRequirements.length>0 && companySubmissions.length>0 && <DataTableView ReqData={[]} SubData={[]} ECIData={companyECI} POData={companyPO} MarginData={[]} which={"EciPo"} tabOf={"company"}/>}
            {Location.pathname==="/companydashboard" && companyRequirements.length>0 && companySubmissions.length>0 && <DataTableView ReqData={[]} SubData={[]} ECIData={[]} POData={[]} MarginData={companyMargim} which={"Margin"} tabOf={"company"}/>} */}
        </div>
    )
}